import React from "react"
import styled from "styled-components"
import { animated } from "react-spring"
import Logo from "../../images/logo-white.svg"
import LinkIcon from "../../images/link.svg"
import { Link } from "gatsby"

import MenuMobile from "./mobile-nav"


const CloseButton = ({ handleToggle }: any) => {
  const Close = styled.div`
    // width: 2rem;
    // height: 2rem;
    position: absolute;
    top: 2rem;
    right: 5%;
    cursor: pointer;
    border-bottom: 3px solid ${props => props.theme.colors.white};
    line-height: 2;
    color: ${props => props.theme.colors.white};
  `

  const Bar = styled.div`
    width: 100%;
    height: 2px;
    background: ${props => props.theme.colors.secondary};
    &:first-of-type {
      transform: rotate(-45deg);
    }
    &:last-of-type {
      transform: rotate(45deg);
    }
  `
  

  return (
    <Close onClick={handleToggle}>
      {/* <Bar />
      <Bar /> */}
      Close
    </Close>
  )
}

const MobileMenu = ({ handleToggle, style }: any) => {
  const Wrapper = styled(animated.div)`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: ${(props) => props.theme.colors.primary};
    display: flex;
    flex-direction: column;
    // justify-content: center;
    z-index: 2000;
    overflow: scroll;
    nav {
      //margin-top: 30rem;
    }
   
    svg {
      width: 120px;
      margin: 2rem 0 7rem 1.75rem;
      g {
        path {
          fill: #ffffff;
        }
        
      }
    }
    ul {
      ul {
        border-bottom: 3px solid #FFF !important;
        width: 100% !important;
        padding-bottom: 1rem !important;
        margin-bottom: 1rem;
      }
  
    }

    li {
      display: block;
      text-align: left;
      line-height: 1.2;
  
    }
    a {
      
      font-size: 30px;
      @media screen and (min-width: ${(props) =>
        props.theme.breakpoints.tablet}) {
        font-size: 30px;
        line-height: 62px;
      }
      
      @media screen and (min-width: ${(props) =>
        props.theme.breakpoints.phone}) {
        // font-size: 25px;
        // line-height: 1.4;
      }
      color: ${(props) => props.theme.colors.light};
      &.active {
        color: ${(props) => props.theme.colors.light};
        //border-color: ${(props) => props.theme.colors.light};
      }
    }
    a.grow {
      position: relative;
    }
    a.grow:before {
      content: "";
      position: absolute;
      width: 100%;
      height: 1px;
      bottom: -4px;
      left: 0;
      background-color: ${(props) => props.theme.colors.secondary};
      visibility: hidden;
      width: 0;
      transition: all 0.2s ease-in-out;
    }
    a.grow:hover:before {
      visibility: visible;
      width: 100%;
    }
    a.grow.active:before {
      visibility: visible;
      width: 100%;
    }

  `;

  


  // useBodyScrollLock()
  return (
    <Wrapper style={style} onClick={handleToggle}>
      {/* <Logo /> */}
      <Link to="/" aria-label="Home">
        <Logo />
      </Link>
      <CloseButton handleToggle={handleToggle} />
      <MenuMobile />
    </Wrapper>
  );
}

export default MobileMenu
